var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBredcrumbsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.00002C11.6254 9.19698 11.5868 9.39206 11.5115 9.57406C11.4362 9.75606 11.3257 9.92138 11.1863 10.0605L7.21577 14.0303L6.15527 12.9698L10.125 9.00002L6.15527 5.03027L7.21577 3.96977L11.1855 7.93952C11.3251 8.07861 11.4357 8.2439 11.5111 8.4259C11.5866 8.6079 11.6253 8.80301 11.625 9.00002Z",
    fill: "#1273C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBredcrumbsIcon);
export default __webpack_public_path__ + "static/media/bredcrumbs_icon.d32751e61626b20944344f34d9f918fd.svg";
export { ForwardRef as ReactComponent };